import { API_BASE } from "../utils/baseapiurl";

class AgentHieararchyAPI {
	async getAgentHierarchy({ agent_id = "", period = "", signal = null } = {}) {
		const params = new URLSearchParams({
			...(agent_id ? { agent_id } : {}),
			...(period ? { period } : {}),
		});

		const response = await fetch(`${API_BASE}/hierarchy?${params}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": window.wpApiSettings?.nonce || "",
			},
			credentials: "include",
			...(signal ? { signal } : {}),
		});

		if (!response.ok) {
			throw new Error("Failed to fetch agent hierarchy");
		}

		return await response.json();
	}
}

export default new AgentHieararchyAPI();
